import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Icon, Input, Menu, Dropdown } from 'semantic-ui-react';
import { QuotationFilter } from '../config';

class QuotationMenu extends Component {
    state = {
        activeItem: ''
    }

    handleFilterClick(cat, e) {
        this.props.history.push('/quotations/' + cat);
    }

    render() {
        const { activeItem } = this.state;
        const { filter } = this.props.quote;
        console.log(filter)

        return (
            <Menu fixed='left' vertical style={{ marginTop: '5em', marginLeft: '0em' }} >
                <Dropdown item text='Filter'>
                <Dropdown.Menu>
                {
                    QuotationFilter.map((cat) => (
                        <Dropdown.Item key={cat} text={cat} active={filter===cat} onClick={this.handleFilterClick.bind(this, cat)}/>
                    ))
                }
                </Dropdown.Menu>
                </Dropdown>
            </Menu>
        )
    }
}

const mapStateToProps = ({ quote }) => {
    return { quote }
}

export default connect(mapStateToProps)(QuotationMenu);
